/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, {css} from 'styled-components';
import {CpdsAccordionTypes} from "../constants";
import {themeToken} from '../../utils/cpds-utils';
import {getOverrideFontFamily} from "components/common/cpds/token/shared/common/fontfamilies.token";

/* Note: By default, this component is rendered as a 'div' element.
If your use case requires a different HTML element, please update the component accordingly.
Get the the token please use cpds props ex: ${cpds?.button_primary_background_color}

Start styles for component here
Your Styles goes here
End styles for component here

Styles overrides - Do not Remove This Code Block
Data feed styles overrides goes here

*/
const CpdsAccordionStyleTag = styled.div`
  ${({theme: {styles: {cpds}}, ...props}) => {
    const token = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`

      ${(props) => props?.styleOverrides}
    `;
  }}
`;

const CpdsAccordionHeading = styled.div`
  ${({theme: {styles: {cpds}}, ...props}) => {
    const {token} = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      display: flex;
      align-items: center;
      border-top: ${props => (props.defaultBorders ? (token.accordion_border_color || '#D1D5E2') : 'none')};
      padding: 12px 0;
      cursor: pointer;

      ${(props) => props?.styleOverrides}
    `;
  }}
`;

const CpdsAccordionLabel = styled.span`
  ${({theme: {styles: {cpds}}, ...props}) => {
    const {token} = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      color: ${token.accordion_secondary_text_color || '#676A7D'};
      font-family: ${getOverrideFontFamily(token.accordion_label_font_family_key)};
      font-size: 12px !important;
      font-weight: 400 !important;
      line-height: 16px !important;
      margin-right: 8px;
      flex-basis: 74px;
      flex-shrink: 0;

      ${(props) => props?.styleOverrides}
    `;
  }}
`;

const CpdsAccordionTitle = styled.h5`
  ${({theme: {styles: {cpds}}, ...props}) => {
    const {token} = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      flex: 1;
      font-family: ${props => (props.type === CpdsAccordionTypes.LONG ? getOverrideFontFamily(token.accordion_title_long_font_family_key) : getOverrideFontFamily(token.accordion_title_short_font_family_key))}
      font-size: ${props => (props.type === CpdsAccordionTypes.LONG ? '24px' : '16px')} !important;
      font-weight: ${props => (props.type === CpdsAccordionTypes.LONG ? '250' : '500')} !important;
      line-height: ${props => (props.type === CpdsAccordionTypes.LONG ? '32px' : '24px')} !important;
      color: ${token.accordion_primary_text_color || '#0C0E1C'};

      ${(props) => props?.styleOverrides}
    `;
  }}
`;

const CpdsAccordionBody = styled.div`
  ${({theme: {styles: {cpds}}, ...props}) => {
    const {token} = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      overflow: auto;

      ::-webkit-scrollbar {
        display: none;
      }

      -ms-overflow-style: none;
      scrollbar-width: none;
      max-height: ${props => (props.expand ? props.maxHeight ?? '200vh' : '0px')};
      transition: max-height 1.2s ease-in-out, padding 1.2s ease-in-out, border-top 1.2s ease-in-out;
      border-top: ${props => (props.defaultBorders ? (props.type === CpdsAccordionTypes.LONG && props.expand ? token.accordion_border_color || '#D1D5E2' : 'none') : 'none')};
      padding: ${props => (props.type === CpdsAccordionTypes.LONG && props.expand ? '12px 0' : '0')};

      ${(props) => props?.styleOverrides}
    `;
  }}
`;

const CpdsAccordionBodyHeader = styled.div`
  ${({theme: {styles: {cpds}}, ...props}) => {
    const token = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      ${(props) => props?.styleOverrides}
    `;
  }}
`;

const CpdsAccordionBodyContent = styled.div`
  ${({theme: {styles: {cpds}}, ...props}) => {
    const token = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
    return css`
      margin-left: 80px;

      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export {
  CpdsAccordionStyleTag,
  CpdsAccordionHeading,
  CpdsAccordionTitle,
  CpdsAccordionLabel,
  CpdsAccordionBody,
  CpdsAccordionBodyHeader,
  CpdsAccordionBodyContent
};
